import { render, staticRenderFns } from "./Productivity_structure.vue?vue&type=template&id=4492a44e"
import script from "./Productivity_structure.vue?vue&type=script&lang=js"
export * from "./Productivity_structure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports